// D17b (d17b-v01 + v02 + v03; pareceres d17b-design*): a guarda de saída do detalhe vale para TODO caminho que troca ou abandona o ticket.
// Antes morava no FilaAbas (sairDoDetalhe da D17). Aqui:
//  - motivoTrabalho(): SÓ trabalho (gravação, envio de áudio/WhatsApp, texto, anexo). Usado pelo beforeunload, pelo D08 e por "posso descartar?"
//    (LICOES 50: Swal/Loader na tela nunca decidem se há trabalho).
//  - motivoClique(): 'ocupado' (Swal visível / #loading-div visível) ou motivoTrabalho(). SÓ para engolir cliques/submits.
//  - sair(origem, el, op) → Promise<boolean>: chip / tentar / limpar (D17/D20). Nunca rejeita; `saindo` solto em qualquer desfecho.
//  - captura em WINDOW (fase de captura, antes do jQuery delegado no document, do FilaSelecao e do FilaAbas): .tk-item-abrir,
//    .tk-fila .tk-assumir (só de item que NÃO é o ticket aberto), .tk-proximo e o submit do form.tk-busca. Sem motivo, o evento segue intacto.
//    Os botões da camada D19 (.tk-camada-assumir / .tk-camada-reabrir) nunca são interceptados.
//  - Clique sintético do próprio componente (re-clique, botão temporário, D08) passa pela captura via `liberar` — sempre zerado em finally.
//  - Gravador (D17b-2 = a): window.tkGravador {estado, cancelar} do Chats.js soma ao DOM (1/2/3 = gravando; 4 = enviando). Sem ele, vale o DOM (G3a/G3b/G3c).
//  - beforeunload: pergunta (diálogo nativo) só com trabalho e fora do silêncio que segue um descarte confirmado.
//  - D35 v18 §2.1 (G18-F1/F2, os dois degraus do lab talk.js:2547-2549): FECHAR o ticket = clique no card já aberto ou Esc. Passa pela
//    mesma guarda (sair('fechar')) e volta ao vazio da D17. Mora aqui, e não no FilaSelecao: só a captura em window chega antes do .bt-ajax
//    (jQuery delegado no document), e é ela que tem de segurar o POST do re-clique.

const SILENCIO_MS = 60000;
const ACEITO_MS = 60000;
// Seletores do legado (Chats.js / EmailThread) num lugar só (R1 da d17-v01). Sempre dentro de .open-ticket-detail.
const GUARDA = {
    gravando: '#overlay-rec-audio-chat',
    parar: '#stopButton',
    formZap: 'form#send-message',
    erroParam: '.fDerror',
    textos: 'form#send-message textarea[name="content"], .tk-mail-form textarea, form#send-message .validate-flow_paramns',
    anexos: '.tk-mail-form input[type="file"]',
    // D35 bloco H (d35-v20 §5.3): o texto e o anexo não enviados da 5ª janela também são trabalho (trocar de ticket, sair da página)
    olhoTextos: '#tk-olho textarea.tk-olho-texto',
    olhoAnexos: '#tk-olho .tk-olho-pe input[type="file"]',
};
// DD-04 (docs/oportunidades-2027/02-design/dd04-mapa.md M2/M3): os seletores da tela entram pelo init(opts). Sem opts = os de sempre (Tickets).
// O diff deste arquivo é só literal → SEL.chave (+ o gancho aoEsvaziar, M8). NADA = ':not(*)' (não casa nada) fica no mapa de quem chama.
const PADRAO = {
    filaId: 'tk-fila', statusId: 'tk-fila-status', detalhe: '.open-ticket-detail', aberto: '.open-ticket-detail .tk-faixa[data-ticket]',
    barra: '.tk-faixa[data-ticket]', lista: '#tk-fila-itens', item: '.tk-item', abrir: '.tk-item-abrir', vazio: 'p.tk-detalhe-vazio',
    assumirItem: '.tk-assumir', assumir: '.tk-fila .tk-assumir', proximo: '.tk-proximo', camada: '.tk-camada .tk-camada-assumir, .tk-camada .tk-camada-reabrir',
    tela: '.tk-tela', voltar: '.tk-head-voltar', attrPainel: 'data-tk-painel', buscaForm: 'form.tk-busca', corpo: '.tk-detalhe-corpo',
    olhoTextos: GUARDA.olhoTextos, olhoAnexos: GUARDA.olhoAnexos,
    aoEsvaziar: null,   // gancho (SaidaDetalhe:213-216): a página nova fecha = volta à lista, em vez do <p> vazio dos Tickets
};
let SEL = PADRAO;   // não é `S`: ocupado(), perguntar() e aoTeclar() já têm `const S = swal()` local

const SaidaDetalhe = function () {

    let ativo = false;
    let T = null;
    let saindo = false;          // um fluxo de guarda por vez (2º gatilho é ignorado)
    let liberado = null;         // nó cujo clique sintético passa pela captura (zerado em finally)
    let silenciado = false;
    let silencio = null;         // { teto, obsDet, obsLd }
    const aceitos = new Map();   // ticket_id → timeout: descarte confirmado num Assumir combinado (D08 abre sem 2ª pergunta)

    const textos = () => {
        if (T) return T;
        const f = document.getElementById(SEL.filaId);
        try { T = JSON.parse((f && f.dataset.textos) || '{}') || {}; } catch (e) { T = {}; }
        return T;
    };
    const t = (k, p) => String(textos()[k] || k).replace(/:([a-z]+)/g, (m, c) => (p && c in p ? String(p[c]) : m));
    const anunciar = (s) => { const st = document.getElementById(SEL.statusId); if (st) { st.textContent = ''; st.textContent = s; } };
    const detalheEl = () => document.querySelector(SEL.detalhe);
    const visivel = (el) => !!el && el.isConnected && getComputedStyle(el).display !== 'none';
    const swal = () => (window.Swal && typeof window.Swal.fire === 'function' ? window.Swal : null);
    const loaderVisivel = () => visivel(document.getElementById('loading-div'));
    const focar = (el) => { if (el && el.isConnected) el.focus({ preventScroll: true }); };
    const gravador = () => (window.tkGravador && typeof window.tkGravador.estado === 'function' && typeof window.tkGravador.cancelar === 'function') ? window.tkGravador : null;
    const estadoGravador = () => { const g = gravador(); if (!g) return null; try { const e = g.estado(); return typeof e === 'number' ? e : null; } catch (err) { return null; } };

    const aberto = () => {
        const f = document.querySelector(SEL.aberto);
        if (f) return parseInt(f.dataset.ticket, 10) || null;
        const a = document.querySelector(SEL.lista + ' ' + SEL.item + '[aria-current="true"]');
        return a ? parseInt(a.id.replace('opportunity_', ''), 10) || null : null;
    };
    const idDoItem = (el) => { const it = el ? el.closest(SEL.item) : null; return it ? parseInt(it.id.replace('opportunity_', ''), 10) || null : null; };

    // ---------- motivos ----------
    // Texto/anexo/envio (G4, G5), sem olhar o gravador.
    const motivoEscrito = (det) => {
        const presos = det ? Array.from(det.querySelectorAll(GUARDA.formZap)).filter(f => f.classList.contains('waiting-send')) : [];
        if (presos.some(f => !Array.from(f.querySelectorAll(GUARDA.erroParam)).some(visivel))) return 'descartar_envio';   // G4
        // espaço não é trabalho (d17-v03 §2): trim nos compositores e nos parâmetros de template
        const cheio = (el) => String(el.value || '').trim() !== '';
        const comArq = (el) => el.files && el.files.length > 0;
        const texto = (det ? Array.from(det.querySelectorAll(GUARDA.textos)).some(cheio) : false) || Array.from(document.querySelectorAll(SEL.olhoTextos)).some(cheio);
        const anexo = (det ? Array.from(det.querySelectorAll(GUARDA.anexos)).some(comArq) : false) || Array.from(document.querySelectorAll(SEL.olhoAnexos)).some(comArq);
        if (texto && anexo) return 'descartar_ambos';                                                                       // G5
        if (texto) return 'descartar_texto';
        if (anexo) return 'descartar_anexo';
        return null;
    };
    // Áudio: 'gravando' (G3a / G3c com gravador vivo), 'preso' (G3c sem o tkGravador), 'descartar_audio' (G3b), ou null.
    const motivoAudio = (det) => {
        const ov = det ? visivel(det.querySelector(GUARDA.gravando)) : false;
        const stop = det ? det.querySelector(GUARDA.parar) : null;
        const stopVis = !!stop && !stop.classList.contains('d-none');
        const pe = stopVis ? getComputedStyle(stop).pointerEvents : null;
        const preso = stopVis && pe !== 'none' && !ov;
        const enviando = stopVis && pe === 'none';
        const e = estadoGravador();
        if (e !== null) {   // d17b-v02 §4: o estado do gravador SOMA ao DOM
            if (e === 1 || e === 2 || e === 3 || ov || (preso && e !== 0)) return 'gravando';
            if (e === 4 || enviando || preso) return 'descartar_audio';   // preso com estado 0 = microfone negado (nada gravado)
            return null;
        }
        if (ov) return 'gravando';                    // G3a
        if (preso) return 'preso';                    // G3c (d17b-v01 §3.5)
        if (enviando) return 'descartar_audio';       // G3b
        return null;
    };
    const motivoTrabalho = () => {
        const det = detalheEl();
        return motivoAudio(det) || motivoEscrito(det);
    };
    const ocupado = () => {
        const S = swal();
        if (S && S.isVisible()) return 'swal';        // G1
        if (loaderVisivel()) return 'loader';         // G2
        return null;
    };
    const motivoClique = () => (ocupado() ? 'ocupado' : motivoTrabalho());
    // só o rascunho da 5ª janela (R-1 do parecer-d35-bloco-h)
    const motivoPainel = () => {
        const texto = Array.from(document.querySelectorAll(SEL.olhoTextos)).some(el => String(el.value || '').trim() !== '');
        const anexo = Array.from(document.querySelectorAll(SEL.olhoAnexos)).some(el => el.files && el.files.length > 0);
        return texto && anexo ? 'descartar_ambos' : (texto ? 'descartar_texto' : (anexo ? 'descartar_anexo' : null));
    };
    const limparPainel = () => {
        document.querySelectorAll(SEL.olhoTextos).forEach(el => { el.value = ''; });
        document.querySelectorAll(SEL.olhoAnexos).forEach(el => { el.value = ''; });
    };

    // ---------- silêncio do beforeunload (d17b-v02 §5 R3) ----------
    const encerrarSilencio = () => {
        silenciado = false;
        if (!silencio) return;
        clearTimeout(silencio.teto);
        if (silencio.obsDet) silencio.obsDet.disconnect();
        if (silencio.obsLd) silencio.obsLd.disconnect();
        silencio = null;
    };
    const silenciar = (ms) => {
        encerrarSilencio();
        silenciado = true;
        const s = { teto: setTimeout(encerrarSilencio, ms || SILENCIO_MS), obsDet: null, obsLd: null };
        const det = detalheEl();
        if (det) { s.obsDet = new MutationObserver(encerrarSilencio); s.obsDet.observe(det, { childList: true }); }   // (a) o detalhe trocou
        const ld = document.getElementById('loading-div');
        if (ld) {   // (b) o Loader ficou visível por causa da ação e voltou a none sem trocar o detalhe
            let viu = loaderVisivel();
            s.obsLd = new MutationObserver(() => { if (loaderVisivel()) viu = true; else if (viu) encerrarSilencio(); });
            s.obsLd.observe(ld, { attributes: true, attributeFilter: ['style', 'class'] });
        }
        silencio = s;
    };

    // ---------- aceito (D08 sem 2ª pergunta) ----------
    const marcarAceito = (id) => { clearTimeout(aceitos.get(id)); aceitos.set(id, setTimeout(() => aceitos.delete(id), ACEITO_MS)); };
    const consumirAceito = (id) => { if (!aceitos.has(id)) return false; clearTimeout(aceitos.get(id)); aceitos.delete(id); return true; };

    // Clique sintético que a captura deixa passar (R1: sempre zerado, mesmo se o clique não despachar).
    const clicarLiberado = (el) => {
        if (!el) return;
        liberado = el;
        try { el.click(); } finally { liberado = null; }
    };

    // ---------- diálogos ----------
    const bloquear = (S, texto, el) => S.fire({ icon: 'info', title: t('gravando_titulo'), text: texto, confirmButtonText: t('ok'), returnFocus: false })
        .then(() => { focar(el); return false; }, () => { focar(el); return false; });

    // Uma pergunta só. `cfg` = { titulo, texto(motivo), sim } (Assumir/Próximo combinados) ou o padrão da D17.
    // Resolve true quando o atendente confirmou E (se gravava) o gravador foi cancelado; false em qualquer outro desfecho.
    const perguntar = (motivo, el, cfg) => {
        const S = swal();
        if (!S) { anunciar(t('detalhe_aguarde')); return Promise.resolve(false); }   // R2 da D17: sem Swal não descarta
        if (motivo === 'preso') return bloquear(S, t('gravando_preso_msg'), el);
        if (motivo === 'gravando') {
            const g = gravador();
            if (!g) return bloquear(S, t('gravando_msg'), el);                           // sem o tkGravador: bloqueio (d17b-v01 §3.5)
            const extra = motivoEscrito(detalheEl());
            return S.fire({
                icon: 'warning', title: t('gravando_descartar_titulo'),
                text: t('gravando_descartar_msg') + (extra ? ' ' + t(extra) : ''),
                showCancelButton: true, reverseButtons: true, focusCancel: true,
                confirmButtonText: t('descartar_sim'), cancelButtonText: t('descartar_nao'), returnFocus: false,
            }).then((r) => {
                if (!(r && r.isConfirmed)) { focar(el); return false; }
                let p;
                try { p = Promise.resolve(g.cancelar()); } catch (err) { p = Promise.resolve(false); }
                return p.then((ok) => (ok === true ? true : bloquear(S, t('gravando_msg'), el)), () => bloquear(S, t('gravando_msg'), el));
            }, () => { focar(el); return false; });
        }
        const c = cfg || {};
        return S.fire({
            icon: 'warning', title: c.titulo || t('descartar_titulo'),
            text: c.texto ? c.texto(motivo) : t(motivo),
            showCancelButton: true, reverseButtons: true, focusCancel: true,
            confirmButtonText: c.sim || t('descartar_sim'), cancelButtonText: t('descartar_nao'), returnFocus: false,
        }).then((r) => {
            if (r && r.isConfirmed) return true;
            focar(el);
            return false;
        }, () => { focar(el); return false; });
    };

    // Fluxo único com a flag `saindo` (solta em qualquer desfecho, inclusive exceção síncrona; nunca rejeita).
    const comGuarda = (fn) => {
        if (saindo) return Promise.resolve(false);
        saindo = true;
        let p;
        try { p = Promise.resolve(fn()); } catch (err) { p = Promise.resolve(false); }
        return p.then((v) => v === true, () => false).finally(() => { saindo = false; });
    };

    // ---------- esvaziar (D17, passos 2–6) ----------
    const esvaziar = () => {
        const det = detalheEl();
        if (!det) return;
        if (det.children.length === 1 && det.firstElementChild.matches(SEL.vazio)) return;
        const f = det.querySelector(SEL.barra);
        const id = f ? parseInt(f.dataset.ticket, 10) || null : null;
        document.querySelectorAll(SEL.lista + ' ' + SEL.item + '[aria-current]').forEach(el => el.removeAttribute('aria-current'));
        if (SEL.aoEsvaziar) SEL.aoEsvaziar(det, id); else {
        const p = document.createElement('p');
        p.className = 'tk-detalhe-vazio';
        p.textContent = t('detalhe_vazio');
        if (window.jQuery) window.jQuery(det).empty().append(p); else det.replaceChildren(p);
        }
        anunciar(id ? t('detalhe_saiu', { id: id }) : t('detalhe_saiu_sem_id'));
    };

    // D17/D20: chip, Tentar de novo, × da busca. `op.aoConfirmar(origem, el)` = foco do chamador.
    const sair = (origem, el, op) => comGuarda(() => {
        const o = ocupado();
        if (o === 'swal') return false;                                              // G1
        if (o === 'loader') { anunciar(t('detalhe_aguarde')); return false; }        // G2
        const m = motivoTrabalho();
        const seguir = () => { esvaziar(); if (op && op.aoConfirmar) op.aoConfirmar(origem, el); return true; };
        if (!m) return seguir();
        return perguntar(m, el).then((ok) => (ok ? seguir() : false));
    });

    // ---------- captura em window ----------
    const tmp = (orig, classes) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = classes + ' bt-ajax bt-ajax-no-data tk-saida-tmp';
        b.hidden = true;
        b.dataset.ajax = orig.dataset.ajax;
        orig.after(b);
        try { clicarLiberado(b); } finally { b.remove(); }
    };
    // Re-resolve o botão pelo id depois do Swal (R2 da v02): a sync pode ter trocado o miolo.
    const reResolver = (sel, id) => {
        const b = document.querySelector(sel);
        if (!b) { anunciar(t('item_sumiu', { id: id })); return null; }
        if (b.disabled) { anunciar(t('detalhe_aguarde')); return null; }
        return b;
    };

    const fluxoItem = (btn, m) => {
        const id = idDoItem(btn);
        return comGuarda(() => perguntar(m, btn).then((ok) => {
            if (!ok) return false;
            const b = reResolver('#opportunity_' + id + ' ' + SEL.abrir, id);
            if (!b) return false;
            silenciar();
            clicarLiberado(b);   // segue o caminho de hoje: FilaSelecao arma a trava, o .bt-ajax abre
            return true;
        }));
    };
    const fluxoAssumir = (btn, m) => {
        const id = idDoItem(btn);
        return comGuarda(() => perguntar(m, btn, {
            titulo: t('assumir_titulo', { id: id }),
            texto: (m) => t(m) + ' ' + t('assumir_texto', { id: id }),
            sim: t('assumir_sim'),
        }).then((ok) => {
            if (!ok) return false;
            const b = reResolver('#opportunity_' + id + ' ' + SEL.assumirItem, id);
            if (!b) return false;
            marcarAceito(id);
            silenciar();
            tmp(b, 'tk-assumir');   // mesmo POST do bt-confirm, sem a pergunta antiga
            return true;
        }));
    };
    const fluxoProximo = (btn, m) => comGuarda(() => perguntar(m, btn, {
        titulo: t('proximo_titulo'),
        texto: (m) => t(m) + ' ' + t('proximo_texto'),
        sim: t('proximo_sim'),
    }).then((ok) => {
        if (!ok) return false;
        const b = document.querySelector(SEL.proximo + ':not(.tk-saida-tmp)');
        if (!b) return false;
        if (b.disabled) { anunciar(t('detalhe_aguarde')); return false; }
        silenciar();
        tmp(b, 'tk-proximo');   // a classe faz o FilaSelecao e o FilaAbas armarem o D09 como hoje
        return true;
    }));
    const fluxoBusca = (form, m) => {
        const campo = form.querySelector('input[type="search"]');
        return comGuarda(() => perguntar(m, campo).then((ok) => {
            if (!ok) return false;
            silenciar();
            form.submit();   // o submit() nativo não dispara `submit` de novo
            return true;
        }));
    };

    const engolir = (e) => { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); };
    const tratarOcupado = (m) => { if (m === 'ocupado' && loaderVisivel()) anunciar(t('detalhe_aguarde')); };

    // D26 F2e: elemento "ligado" pelo regime CSS (o .open-ticket-detail pode estar escondido pelo painel único sem desligá-lo).
    const noRegime = (el) => { for (let n = el; n && !n.matches(SEL.detalhe); n = n.parentElement) { if (getComputedStyle(n).display === 'none') return false; } return true; };
    const aoClicar = (e) => {
        const alvo = e.target instanceof Element ? e.target : null;
        if (!alvo) return;
        if (liberado && (liberado === alvo || liberado.contains(alvo))) return;   // clique sintético do próprio componente
        // D26 v03 §1 (R-A) + parecer-d26-design-v03 R1 (DEPOIS do `liberado`): no painel único, clique no item JÁ marcado só volta à vista
        // do detalhe. Não é saída: sem guarda, sem rede. stopImmediatePropagation segura o despachante bt-ajax (jQuery) e o FilaSelecao.
        const marcado = alvo.closest(SEL.item + '[aria-current="true"] ' + SEL.abrir);
        const tela = marcado ? document.querySelector(SEL.tela) : null;
        const volta = tela ? document.querySelector(SEL.voltar) : null;
        // parecer-d26-front-v01 F2e: o "← Fila" existe no regime atual se ELE e todo ancestral até o .open-ticket-detail (exclusive) não têm
        // display:none. Nas 3 colunas quem o esconde é o pai .tk-head-barra (o botão fica inline-block). Não é getClientRects: com o painel
        // da fila aberto o próprio detalhe está display:none, e o botão não tem caixa justamente no caso que a regra existe para tratar.
        if (marcado && tela && tela.getAttribute(SEL.attrPainel) === 'fila' && volta && noRegime(volta)) {
            e.preventDefault(); e.stopImmediatePropagation();
            tela.removeAttribute(SEL.attrPainel);
            volta.focus({ preventScroll: true });
            return;
        }
        // G18-F1: clique no card que JÁ é o aberto (e não está abrindo) = fechar. O .bt-ajax do mesmo botão não dispara (sem POST).
        if (marcado && !marcado.closest(SEL.item + '[data-abrindo]') && !marcado.disabled) {
            engolir(e);
            if (saindo) return;
            fechar(marcado);
            return;
        }
        const item = alvo.closest(SEL.abrir + ':not(.tk-saida-tmp)');
        const assumir = item ? null : alvo.closest(SEL.assumir + ':not(.tk-saida-tmp)');
        const proximo = (item || assumir) ? null : alvo.closest(SEL.proximo + ':not(.tk-saida-tmp)');
        const btn = item || assumir || proximo;
        // R-1 do parecer-d35-bloco-h: o Assumir no card do ticket ABERTO e os botões da camada D19 trocam o detalhe sem a guarda do detalhe
        // (d17b-v02 §2), e a troca fecha a 5ª janela. Com rascunho NO PAINEL (de outro ticket), pergunta antes; sem rascunho, segue intacto.
        const camada = alvo.closest(SEL.camada);
        const assumirAberto = !!assumir && idDoItem(assumir) === aberto();
        if (camada || assumirAberto) {
            const b2 = camada || assumir;
            const mp = motivoPainel();
            if (!mp || b2.disabled) return;   // d17b-v02 §2: segue o bt-confirm / .bt-ajax de hoje
            engolir(e);
            if (saindo || ocupado()) { tratarOcupado(ocupado() ? 'ocupado' : null); return; }
            comGuarda(() => perguntar(mp, b2).then((ok) => {
                if (!ok || !b2.isConnected) return false;
                limparPainel();   // descartado: o fechamento do painel pela troca do detalhe não pergunta de novo
                clicarLiberado(b2);
                return true;
            }));
            return;
        }
        if (!btn || btn.disabled) return;
        const m = motivoClique();
        if (m === null) return;   // nada a perder: o evento segue intacto
        engolir(e);
        if (m === 'ocupado' || saindo) { tratarOcupado(m); return; }
        if (item) fluxoItem(item, m); else if (assumir) fluxoAssumir(assumir, m); else fluxoProximo(proximo, m);
    };
    const aoSubmeter = (e) => {
        const form = e.target instanceof Element ? e.target.closest(SEL.buscaForm) : null;
        if (!form) return;
        const m = motivoClique();
        if (m === null) return;
        engolir(e);
        if (m === 'ocupado' || saindo) { tratarOcupado(m); return; }
        fluxoBusca(form, m);
    };
    // G18-F1/F2: fechar volta ao vazio pela guarda de sempre (G1 Swal, G2 véu, G3–G5 trabalho). O foco fica no card que estava aberto.
    const fechar = (btn) => {
        const id = aberto();
        return sair('fechar', btn).then((ok) => {
            if (!ok) return false;
            const b = btn && btn.isConnected ? btn : (id ? document.querySelector('#opportunity_' + id + ' ' + SEL.abrir) : null);
            focar(b);
            return true;
        });
    };
    // G18-F2: Esc fecha o ticket só quando ninguém mais quer o Esc: há ticket aberto, o foco não está num campo, não há Swal nem modal
    // (o 1º Esc é deles) e ninguém o tratou antes. CAPTURA no document: roda antes das camadas que fecham no próprio Esc (LiaFs, gaveta,
    // Swal), e assim ainda as vê abertas; o "×" da busca fica de fora porque o foco está no campo.
    // Camadas que também usam o Esc (sem preventDefault): a LIA de tela cheia (.lia-fs.is-open), a gaveta do contexto (TelaPaineis) e os menus
    // do cabeçalho (Dropdowns). Com qualquer uma aberta, o Esc é dela.
    // R-3 do parecer-d35-bloco-g: o menu dobrável do cabeçalho (usuário, online; Dropdowns.js) também fecha no Esc: aberto, o Esc é dele.
    // FAIL-H3 do QA (a 360): o olho da linha do tempo só existe com a gaveta do contexto ABERTA, e o painel único abre POR CIMA dela. A gaveta
    // só é a camada de cima quando o foco está nela (o Esc dela, TelaPaineis, é por foco); com a 5ª janela aberta e o foco fora da gaveta,
    // o degrau é o do painel. Sem isso o Esc não fazia nada (nem gaveta, nem painel).
    const gavetaEmCima = () => {
        const g = document.querySelector(SEL.corpo + '[data-ctx="aberto"]');
        if (!g) return false;
        const olho = window.tkOlho;
        if (!(olho && typeof olho.aberto === 'function' && olho.aberto())) return true;
        const a = document.activeElement;
        return !!(a && g.contains(a));
    };
    const modalAberto = () => !!document.querySelector('.modal.show, .lia-fs.is-open, [data-dobra-toggle][aria-expanded="true"]') || gavetaEmCima();
    const emCampo = (el) => !!el && (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) || el.isContentEditable);
    // D35 bloco H (d35-v20 §2.6): uma ordem só de Esc para a tela inteira, um degrau por Esc (lab talk.js:2547-2549):
    //   1) Swal / modal (e as camadas do R-3: menus do cabeçalho, gaveta, LIA de tela cheia) → é deles; 2) foco num campo → nada;
    //   3) a 5ª janela aberta → fecha a janela (com a pergunta de descarte se houver texto nela) e o foco volta ao gatilho;
    //   4) ticket aberto → fecha o ticket (G18-F2).
    const aoTeclar = (e) => {
        if (e.key !== 'Escape' || e.defaultPrevented) return;
        const S = swal();
        if ((S && S.isVisible()) || modalAberto()) return;
        if (emCampo(document.activeElement)) return;
        if (saindo) return;
        const olho = window.tkOlho;
        if (olho && typeof olho.aberto === 'function' && olho.aberto()) { e.preventDefault(); olho.fechar('esc'); return; }
        if (!aberto() || !document.querySelector(SEL.aberto)) return;
        e.preventDefault();
        fechar(null);
    };
    // D35 bloco H (§5.3): o MESMO Swal de descarte da D17b para fechar a 5ª janela com texto nela. "Continuar" mantém o painel e o foco no campo.
    const perguntarDescarte = (motivo, el) => comGuarda(() => perguntar(motivo, el));
    const aoSair = (e) => {
        if (silenciado || motivoTrabalho() === null) return;   // LICOES 50: Swal/Loader na tela não calam a pergunta
        e.preventDefault();
        e.returnValue = '';
    };

    return {
        init: function (opts) {
            const s = Object.assign({}, PADRAO, opts || {});   // DD-04: S só muda quando a guarda liga (2º init de outra tela não mexe)
            if (ativo || !document.querySelector(s.detalhe) || !document.getElementById(s.filaId)) return;   // só na tela de tickets nova (ou na do mapa)
            SEL = s;
            ativo = true;
            window.addEventListener('click', aoClicar, true);
            window.addEventListener('submit', aoSubmeter, true);
            window.addEventListener('beforeunload', aoSair);
            document.addEventListener('keydown', aoTeclar, true);   // D35 v18 G18-F2 (captura)
        },
        motivoTrabalho, motivoClique, sair, esvaziar, silenciar, clicarLiberado, consumirAceito, fechar, perguntarDescarte,
        estaSilenciado: () => silenciado,
        anunciar, t,
    };
}();

module.exports = SaidaDetalhe;
